import { render, staticRenderFns } from "./BaseFileUploadMult.vue?vue&type=template&id=4427c504&scoped=true"
import script from "./BaseFileUploadMult.vue?vue&type=script&lang=js"
export * from "./BaseFileUploadMult.vue?vue&type=script&lang=js"
import style0 from "../../node_modules/bulma/css/bulma.css?vue&type=style&index=0&id=4427c504&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427c504",
  null
  
)

export default component.exports